import { Injectable } from '@angular/core';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { Observable, Observer, of, switchMap } from 'rxjs';
import { RiskJsScriptTag } from './risk.js.script-tag.service';

@Injectable({ providedIn: 'root' })
export class RiskJsActionsService {
  private riskJsInstance: any = null;
  private isInitializing = false;

  constructor(
    private readonly riskJsScriptTag: RiskJsScriptTag,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {}

  public initialize(ckoPublicToken: string): Observable<any> {
    if (this.akitaRouterQuery.isBrowser && !this.isInitializing) {
      this.isInitializing = true;
      return this.riskJsScriptTag.promiseInstance().pipe(
        switchMap(async () => {
          try {
            this.riskJsInstance = await ((window as any)?.Risk || {}).create(
              ckoPublicToken,
              { timeoutMs: 10000 }
            );
            this.isInitializing = false;
            return this.riskJsInstance;
          } catch (err) {
            console.log('Breaking Error: ', err);
            this.isInitializing = false;
            return null;
          }
        })
      );
    } else {
      return of();
    }
  }

  public publishRiskData_original(): Observable<string | null> {
    if (this.akitaRouterQuery.isBrowser) {
      return this.riskJsScriptTag.promiseInstance().pipe(
        switchMap(() => {
          if ((window as any)?.Frames && ((window as any)?.Frames || {}).submitCard) {
            return new Observable((observer: Observer<string | null>) => {
              try {
                ((window as any)?.Frames || {})
                  .submitCard()
                  .then((data?: string | null) => {
                    observer.next(data || null);
                    observer.complete();
                  })
                  .catch((error: unknown) => {
                    observer.error(error);
                    observer.complete();
                  });
              } catch (error: unknown) {
                observer.error(error);
                observer.complete();
              }
            });
          } else {
            return of(null);
          }
        })
      );
    } else {
      return of(null);
    }
  }

  public publishRiskData(): Observable<string | null> {
    if (this.akitaRouterQuery.isBrowser) {
      return this.riskJsScriptTag.promiseInstance().pipe(
        switchMap(() => {
          if (this.riskJsInstance) {
            return new Observable((observer: Observer<string | null>) => {
              this.riskJsInstance
                .publishRiskData()
                .then((data?: string | null) => {
                  observer.next(data || null);
                  observer.complete();
                })
                .catch((error: unknown) => {
                  observer.error(error);
                  observer.complete();
                });
            });
          } else {
            return of(null);
          }
        })
      );
    } else {
      return of(null);
    }
  }
}
